import ProjectSession from "../../../core/model2/project/project-session";
import {ProjectTree} from "../../../core/gd-model/tree/@type";


export default function mainMenu_workspaceViews(workspace:ProjectSession):ID[] {

    const project : ProjectTree | null = gd.tree.getProject(workspace.id)

    if (!project) return []

    const views: ProjectTree[] = project.children?.views

    return _.map(views, (project)=>{
        return project.id
    })

}